<template lang="html">
  <div class="user">
    <span class="edit" v-show="!show" @click="edit()">{{message.Sl127}}</span>
    <div class="pic">
      <avatar
        v-if="formOld.imgUrl===''&&formNew.imgUrl===''"
       :username="formOld.name "
       :size="100"
       color="#fff"
      >
      </avatar>
      <img v-if="formOld.imgUrl!==''&&formNew.imgUrl===''" :src="formOld.imgUrl" alt="">
      <el-upload
        v-show="show"
        class="avatar-uploader"
        action="/cydex/api/v1/pic"
        :headers="headers"
        :data="{pic_type:'2'}"
        name="uploadfile"
        :show-file-list="false"
        :on-error="handleAvatarError"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="formNew.imgUrl" :src="formNew.imgUrl" class="avatar">
        <avatar
          v-if="defaultImg"
         :username="formOld.name "
         :size="100"
         color="#fff"
        >
        </avatar>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
    <div class="restore">
      <el-button
        @click="resetImg"
        v-show="show"
        type="text">
        {{message.Sl128}}
      </el-button>
    </div>
    <el-form class="edit-form" style="width:360px;float:left;margin-left:20px;margin-top:25px;margin-bottom:25px;" :model="formNew" ref="rulesForm"  :rules="rules" label-width="120px">
      <el-form-item :label="message.account"   auto-complete="off" style="text-align:left">
        {{ formOld.account }}
        <el-button
          @click="editPass"
          class="change-password"
          type="text">
          {{message.Sl130}}
        </el-button>
      </el-form-item>
      <el-form-item :label="message.name"  prop="name" auto-complete="off" style="text-align:left">
        <el-input v-model.trim="formNew.name" size="small" show-message="false" v-show="show" maxlength="32"></el-input>
        <span v-if="!show">{{ formOld.name }}</span>
      </el-form-item>
      <el-form-item :label="message.Sl129"   auto-complete="off" style="text-align:left">
        {{ formOld.email }}
        <!-- <el-button
          @click="editPass"
          class="change-password"
          type="text">
          {{message.Sl130}}
        </el-button> -->
      </el-form-item>
      <el-form-item :label="message.phone"   auto-complete="off" style="text-align:left" prop="phone">
        <el-input v-model="formNew.phone" size="small" v-show="show" :maxlength="18"></el-input>
        <!-- {{ formOld.phone }} -->
        <span v-if="!show">{{ formOld.phone }}</span>
      </el-form-item>
      <el-form-item :label="message.company"  auto-complete="off" style="text-align:left">
        <span class="text-area-span">{{ formOld.company }}</span>
        <!-- <el-input v-model="formNew.company" size="small" v-show="show"></el-input> -->
      </el-form-item>
      <el-form-item style="margin-top:10px" v-show="show">
        <el-button type="primary" size="small" @click="onSubmit">{{message.Al210}}</el-button>
        <el-button size="small" @click="reset()">{{message.Fl101}}</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="message.Sl130"
      :visible.sync="dialogVisible"
      width="600px"
      append-to-body
      >
      <el-form label-width="80px" :model="formUser" ref="rulesForm2"  :rules="rules2" label-position="top" style="max-width:380px;text-align:left;margin:0 auto;">
        <el-form-item :label="message.Fl103" prop="oldPass">
          <el-input type="password" v-model="formUser.oldPass"  show-message="false"></el-input>
        </el-form-item>
        <el-form-item :label="message.Fl104" prop="newPass">
          <el-input type="password" v-model="formUser.newPass"  show-message="false" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item :label="message.pass2" prop="newPass2">
          <el-input type="password" v-model="formUser.newPass2"  show-message="false" maxlength="32"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{message.Fl101}}</el-button>
        <el-button
          type="primary"
          @click="submitPass"
          >
          {{message.Fl100}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
export default {
  components: {
    Avatar
  },
  data () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l102))
      } else if (value.length > 32) {
        return callback(new Error(this.$lang.ui.prompt.l106))
      } else if (value.length < 2) {
        return callback(new Error(this.$lang.ui.prompt.l107))
      } else {
        callback()
      }
    }
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /\+*\d* *\d.*\d$/
      if (!value) {
        callback()
      } else if (!phoneReg.test(value)) {
        callback(new Error(this.$lang.ui.prompt.l164))
      } else {
        callback()
      }
    }
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l101))
      } else {
        callback()
      }
    }
    var checkPass1 = (rule, value, callback) => {
      const pwdReg = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+)$/
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l101))
      } else if (value.length < 8) {
        callback(new Error(this.$lang.ui.prompt.l108))
      } else if (pwdReg.test(value)) {
        callback(new Error(this.$lang.ui.prompt.l162))
      } else if (value === this.formUser.oldPass) {
        callback(new Error(this.$lang.ui.prompt.l163))
      } else {
        callback()
      }
    }
    var checkPass2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l103))
      } else if (value !== this.formUser.newPass) {
        callback(new Error(this.$lang.ui.prompt.l105))
      } else {
        callback()
      }
    }
    var timeZone = localStorage.getItem('timeZone')
    var token = localStorage.getItem('token')
    var language = localStorage.getItem('language')
    var headers = {
      'x-us-authtype': '1',
      'x-us-token': token,
      'accept-language': language,
      'time-zone': timeZone
    }
    return {
      message: {
        account: this.$lang.ui.form.account,
        phone: this.$lang.ui.form.phone,
        company: this.$lang.ui.form.company,
        name: this.$lang.ui.form.name,
        pass2: this.$lang.ui.form.pass2,
        Fl100: this.$lang.ui.form.l100,
        Fl101: this.$lang.ui.form.l101,
        Fl102: this.$lang.ui.form.l102,
        Al210: this.$lang.ui.app.l210,
        Fl103: this.$lang.ui.form.l103,
        Fl104: this.$lang.ui.form.l104,
        Sl127: this.$lang.ui.system.l127,
        Sl128: this.$lang.ui.system.l128,
        Sl129: this.$lang.ui.system.l129,
        Sl130: this.$lang.ui.system.l130
      },
      headers: headers,
      show: false,
      defaultImg: false,
      dialogVisible: false,
      formUser: {
        oldPass: '',
        newPass: '',
        newPass2: ''
      },
      formOld: {
        name: 'null',
        email: '',
        phone: '',
        company: '',
        imgUrl: ''
      },
      formNew: {
        name: '',
        email: '',
        phone: '',
        company: '',
        imgUrl: ''
      },
      rules: {
        name: [
          { validator: checkName, trigger: 'blur' }
        ],
        phone: [
          { validator: checkPhone, trigger: 'blur' }
        ]
      },
      rules2: {
        oldPass: [
          { validator: checkPass, trigger: 'blur' }
        ],
        newPass: [
          { validator: checkPass1, trigger: 'blur' }
        ],
        newPass2: [
          { validator: checkPass2, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.user()
  },
  methods: {
    beforeAvatarUpload (file) {
      this.defaultImg = false
      var type = file.type.split('/')
      type = type[0]
      const isLt1M = file.size / 1024 < 200
      const isImg = type === 'image'
      if (!isImg) {
        this.$message.warning(this.$lang.ui.prompt.l114)
      }
      if (!isLt1M) {
        this.$message.warning(this.$lang.ui.prompt.l115)
      }
      return isImg && isLt1M
    },
    handleAvatarError () {
      this.$message({
        message: this.$lang.ui.prompt.l116,
        type: 'error',
        duration: 3 * 1000
      })
    },
    handleAvatarSuccess (res, file) {
      this.formNew.imgUrl = res.pic_url
    },
    onSubmit () {
      this.$refs['rulesForm'].validate((vaild) => {
        if (vaild) {
          if (this.defaultImg) {
            var imgUrl = ''
          } else {
            if (this.formNew.imgUrl === '') {
              imgUrl = this.formOld.imgUrl
            } else {
              imgUrl = this.formNew.imgUrl
            }
          }
          this.$http.put('/cydex/api/v1/user', {
            'user_name': this.formNew.name,
            'mobile_phone': this.formNew.phone,
            'company': this.formNew.company,
            'pic_url': imgUrl
          })
            .then(response => {
              this.$message({
                message: this.$lang.ui.prompt.l117,
                type: 'success',
                duration: 4000
              })
              this.show = false
              this.formOld.name = this.formNew.name
              this.formOld.phone = this.formNew.phone
              this.formOld.company = this.formNew.company
              this.formOld.imgUrl = imgUrl
              this.formNew.imgUrl = ''
              this.$refs['rulesForm'].resetFields()
              this.$api.getUser(response => {
                this.$store.dispatch('addUser', response)
              })
            // var newData = {
            //   imgUrl: response.data.imgUrl,
            //   name: response.data.name,
            //   email: response.data.email,
            //   uid: response.data.uid
            // }
            // this.$store.dispatch('addUser', newData)
            })
        }
      })
    },
    submitPass () {
      this.$refs['rulesForm2'].validate(vaild => {
        if (vaild) {
          this.$http.put('/cydex/api/v1/password', {
            password_old: this.formUser.oldPass,
            password_new: this.formUser.newPass2
          })
            .then(response => {
              this.dialogVisible = false
              this.$message({
                message: this.$lang.ui.prompt.l118,
                type: 'success',
                duration: 4000
              })
            })
            .catch(error => {
              if (error.response.data.errno === 202) {
                this.$message({
                  message: this.$lang.ui.prompt.l119,
                  type: 'error',
                  duration: 4000
                })
              }
            })
        }
      })
    },
    edit () {
      this.show = true
      this.formNew.name = this.formOld.name
      this.formNew.phone = this.formOld.phone
      this.formNew.company = this.formOld.company
    },
    editPass () {
      this.dialogVisible = true
      if (this.$refs['rulesForm2']) {
        this.$refs['rulesForm2'].resetFields()
      }
      this.formUser.newPass2 = ''
      this.formUser.newPass = ''
      this.formUser.oldPass = ''
    },
    resetImg () {
      this.formNew.imgUrl = ''
      this.defaultImg = true
    },
    reset () {
      this.formNew.imgUrl = ''
      this.show = false
      this.defaultImg = false
      this.$refs['rulesForm'].resetFields()
    },
    user () {
      this.$http.get('/cydex/api/v1/user')
        .then(response => {
          this.formOld.imgUrl = response.data.pic_url
          this.formOld.name = response.data.name
          this.formOld.email = response.data.email
          this.formOld.phone = response.data.mobile_phone
          this.formOld.company = response.data.company
          this.formOld.account = response.data.account
        })
    }
  }
}
</script>

<style lang="css" scoped>
.user {
  position: relative;
  width: 90%;
  margin: 0 auto;
  padding: 2px 25px;
  overflow: hidden;
  border-radius: 4px;
  background-color: #fff;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
}
.edit {
  position: absolute;
  cursor: pointer;
  color: #007bc5;
  top: 20px;
  right: 25px;
  /* display: none; */
  font-size: 14px;
  font-weight: 600;
}
.user:hover .edit {
  display: block;
}
.pic {
  position: relative;
  margin-top: 20px;
  width: 100px;
  height: 100px;
  border-radius: 100px;
  overflow: hidden;
  float: left;
}
.avatar {
  border-radius: 100px;
}
.pic img {
  background-color: #fff;
  width: 100px;
  height: 100px;
}
.text-area-span {
  width: 100%;
  display: block;
  word-wrap: break-word;
}
.avatar-uploader {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  width: 100px;
  height: 100px;
  text-align: center;
  border-radius: 100px;
}
.avatar-uploader-icon {
  color: rgba(255, 255, 255, 0.5);
  margin-top: 25px;
  font-size: 50px;
}
.edit-form .el-form-item {
  margin-bottom: 2px;
}
.edit-form .el-input {
  position: absolute;
  left: 0;
}
.change-password {
  margin-left: 10px;
}
.restore {
  position: absolute;
  width: 160px;
  text-align: center;
  z-index: 3;
  left: 0;
  top: 125px
}
</style>
